import type { Filters } from '@/types/filters.ts';

export type FiltersStorage = {
  load: () => Filters | null;
  save: (filters: Filters) => void;
};

export class LocalStorageManager implements FiltersStorage {
  private STORAGE_KEY = 'yb-filters';
  private isRoadbook = false;

  constructor() {
    // Antoine - 05/08/25 - fix temporaire pour le RB => pas de localstorage
    if (document.querySelector('yb-rdbk-list')) {
      this.isRoadbook = true;
    }
    // const isYoubookStorage = document.querySelector('yb-list');
    // isYoubookStorage ? this.STORAGE_KEY = 'yb-filters' : this.STORAGE_KEY = 'rdbk-filters';
  }

  load(): Filters | null {
    if (this.isRoadbook)
      return null;
    const savedFilters = localStorage.getItem(this.STORAGE_KEY);
    if (!savedFilters)
      return null;
    const parsedFilters = JSON.parse(savedFilters);
    const validTTS = (Date.now() - parsedFilters.tts) < (30 * 60 * 1000);
    if (!validTTS)
      localStorage.removeItem(this.STORAGE_KEY);
    return validTTS ? parsedFilters.data : null;
  }

  save(filters: Filters) {
    if (this.isRoadbook)
      return;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      data: filters,
      tts: Date.now(),
    }));
  }
}
